<div class="c-site-left-panel-inner" id="divLeftPanelInner">
  <div class="c-site-left-panel-profile" id="divLeftPanelProfile">
    <div class="c-site-left-panel-profile-photo" id="divPhoto">
      <img
        id="imgProfile"
        [src]="userDetail && userDetail.profilePicture ? userDetail.profilePicture : '../../../../assets/images/icon-login-profile.svg'"
      />
    </div>
    <div class="c-site-left-panel-profile-text" id="divProfileTxt">
      <span id="spn1"></span>
      <a id="aHrefTag" href="#"></a>
    </div>
  </div>
  <div class="c-site-left-panel-menu" id="divLeftPanelMenu">
    <!-- <div class="c-site-left-panel-menu-filter" id="divLeftPanelFilter">
      <mat-form-field appearance="fill" class="mat-block" id="matFrmSearch">
        <input matInput [placeholder]="'left_panel.search_menu' | translate" id="txtSearch" />
        <mat-icon matPrefix id="matIconSearch">search</mat-icon>
      </mat-form-field>
    </div> -->
    <div class="c-site-left-panel-menu-list">
      <mat-nav-list>
        <mat-accordion>
          <app-menuitems *ngFor="let item of menuItems index as i" [depth]="i+1" [item]="item">
          </app-menuitems>
        </mat-accordion>
      </mat-nav-list>
    </div>
  </div>
</div>
